import React from 'react';
import { createPortal } from 'react-dom';
import { usePageSourcesSlot } from '../contexts/PageSourcesContext';

/** Renders its children (data badges, provenance notes) in the page's bottom "Sources" block. */
export function PageSources({
  children
}: {
  children: React.ReactNode;
}) {
  const slot = usePageSourcesSlot();
  if (!slot) return null;
  return createPortal(<div className="flex flex-wrap items-center gap-2" data-id="element-659" data-mp="fb7j8mrjyykz">{children}</div>, slot);
}